import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { HelpButton } from 'components/common/census/HelpButton';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import IMQCensusUploadPageStore, {
  IMQCensusUploadPageStoreContext,
  useIMQCensusUploadPageStore,
} from 'store/pages/quote/imq-add-employees/census/pageStore';
import { BasicCensusFlowLayout } from 'components/common/census/BasicCensusFlowLayout';
import PageInFlowNoSidebarLayout from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import { buildGroupContextMoreInfoBlobProps } from 'components/common/group/GroupContextMoreInfoBlob';
import { RouteV2Id } from 'routes/routesConfigV2';

/* TESTING_POLICY: CYPRESS_ONLY */

const PageContent: React.FC = observer(() => {
  const pageStore = useIMQCensusUploadPageStore();
  const { groupId, periodId, cartId } = useQuoteDomainParams();
  const { flowDelegate } = pageStore;

  useEffect(() => {
    void flowDelegate.getFlowInitialData();
  }, []);

  return (
    <PageInFlowNoSidebarLayout
      contentWidth="standard"
      domainParams={{ groupId, periodId, cartId }}
      pageId={RouteV2Id.IMQ_ADD_EMPLOYEES_CENSUS_UPLOAD}
      pageHeader={{ subtitle: <HelpButton /> }}
      moreInfoBlob={
        flowDelegate.groupInfoDelegate.moreInfoBlobInput
          ? buildGroupContextMoreInfoBlobProps(flowDelegate.groupInfoDelegate.moreInfoBlobInput)
          : undefined
      }
      isInfoSectionLoading={flowDelegate.isFlowDataLoading}
    >
      <BasicCensusFlowLayout pageStore={pageStore} />
    </PageInFlowNoSidebarLayout>
  );
});

const IMQCensusUploadPage: React.FC = () => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();

  const pageStore = useMemo(
    () => new IMQCensusUploadPageStore({ groupId, enrollmentPeriodId: periodId, cartId }),
    [groupId, periodId, cartId],
  );

  return (
    <IMQCensusUploadPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </IMQCensusUploadPageStoreContext.Provider>
  );
};

export default IMQCensusUploadPage;
